$(document).ready(function () {
    $(".botPinClear").click(function(event){
        $("#pinPass").val('');
        $("#pinDots").html('');
    });
    $(".botPinNumber").click(function(event){
        //alert(event.target.id)
        var newnumber = event.target.id;
        $("#pinPass").val($("#pinPass").val() + newnumber);
        if (['WRONG PIN', 'PIN ERRADO', 'MAUVAISE BROCHE'].includes($("#pinDots").html()))  {
            $("#pinDots").html('');
        }
        $("#pinDots").html($("#pinDots").html() + '&nbsp;<i class="fas fa-circle"></i>&nbsp;');
    });

    $("#pinOk").click(function(){
        var self = this;
        $(self).fadeOut();
        var pincheck = $("#pinPass").val();
        var pinpacient = $("#pinPacient").val();
        var pinurl = $("#pinUrl").val();
        fetch($("[name=pin-verify]").get(0).content, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                pin: pincheck
            })
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data.ok) {
                $('body').addClass('is-loading-fill');
                window.location=pinurl;
            } else {
                $("#pinPass").val('');
                $("#pinDots").html(document.querySelector('meta[name=wrong_pin]').content);
                $(self).fadeIn('slow', function() {
                });
            }
        })
    });

    $(".botPinNumber, .botPinClear").keypress(function(event){
        if(event.keyCode == 13){
          $(event.target).click();
        }
    });
});
